import { createApi } from "@reduxjs/toolkit/query/react";
import { btBaseQuery } from "src/Common/common";

// Define a service using a base URL and expected endpoints
export const uomApi = createApi({
	reducerPath: "uomApi",
	baseQuery: btBaseQuery,
	tagTypes: ["Uom"],

	endpoints: (builder) => ({
		getUoms: builder.query<bt_muom[], void>({
			query: () => `uom/`,
			providesTags: ["Uom"],
		}),
		getUomById: builder.query<bt_muom, string>({
			query: (id) => `uom/byid/${id}`,
			providesTags: ["Uom"],
		}),
		insertUom: builder.mutation({
			query: (uom) => ({
				url: `/uom/`,
				method: "POST",
				body: uom,
			}),
			invalidatesTags: ["Uom"],
		}),
		updateUom: builder.mutation({
			query: (uom) => ({
				url: `/uom/`,
				method: "PUT",
				body: uom,
			}),
			invalidatesTags: ["Uom"],
		}),
		deleteUom: builder.mutation({
			query: (uom) => ({
				url: `/uom/${uom.uo_id}`,
				method: "DELETE",
				body: uom,
			}),
			invalidatesTags: ["Uom"],
		}),
	}),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
	useGetUomsQuery,
	useGetUomByIdQuery,
	useInsertUomMutation,
	useUpdateUomMutation,
	useDeleteUomMutation,
} = uomApi;
